import { createApp } from 'vue'
import App from './App.vue'
import './scss/custom.scss'
import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_HOST + '/v1'

createApp(App).mount('#app')
